<mat-chip-set data-qa-id="wfd-priority-returner-chips">
    <div [ngClass]="{'stack-vertical': displayVertical }" >
        @switch (wfdPriority) { 
            @case (WfdPriorityTypeValue.Referral) {
            <nova-wfd-referral-chip></nova-wfd-referral-chip>
            }
        
            @case (WfdPriorityTypeValue.Vip) {
                <nova-wfd-vip-chip></nova-wfd-vip-chip>
            }
        }
        @if(isWfdReturner) {
            <nova-wfd-returner-chip></nova-wfd-returner-chip>
        }
    </div>
   

</mat-chip-set>

